import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import SEO from "@/components/SEO";
import PageHero from "@/components/site/PageHero";
import { ArrowUpRight } from "lucide-react";

const staticGroups = [
  { title: "Main", links: [["Home", "/"], ["About", "/about"], ["Services", "/services"], ["Portfolio", "/portfolio"], ["Pricing", "/pricing"], ["Blog", "/blog"], ["Careers", "/careers"], ["FAQ", "/faq"], ["Contact", "/contact"]] },
  { title: "Legal", links: [["Privacy Policy", "/privacy"], ["Terms & Conditions", "/terms"], ["Sitemap", "/sitemap"]] },
];

export default function Sitemap() {
  const [services, setServices] = useState([]);
  const [blog, setBlog] = useState([]);
  const [portfolio, setPortfolio] = useState([]);

  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data)).catch(() => {});
    api.get("/blog").then((r) => setBlog(r.data)).catch(() => {});
    api.get("/portfolio").then((r) => setPortfolio(r.data)).catch(() => {});
  }, []);

  const Group = ({ title, items }) => (
    <div>
      <h2 className="mb-5 font-heading text-lg font-semibold text-white">{title}</h2>
      <ul className="space-y-3">
        {items.map(([label, to]) => (
          <li key={to}>
            <Link to={to} className="group inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-vantage">
              {label} <ArrowUpRight className="h-3.5 w-3.5 opacity-0 transition-opacity group-hover:opacity-100" />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <>
      <SEO title="Sitemap" description="A complete map of all pages on the Web Vantage Enterprises website." path="/sitemap" />
      <PageHero overline="Sitemap" title="Find your way around" subtitle="Every page on our site, organised for you." crumbs={[{ label: "Sitemap" }]} />
      <section className="py-20 lg:py-28">
        <div className="container-wv grid gap-12 sm:grid-cols-2 lg:grid-cols-4">
          {staticGroups.map((g) => <Group key={g.title} title={g.title} items={g.links} />)}
          <Group title="Services" items={services.map((s) => [s.title, `/services/${s.slug}`])} />
          <Group title="Portfolio" items={portfolio.map((p) => [p.title, `/portfolio/${p.slug}`])} />
          <Group title="Blog" items={blog.map((b) => [b.title, `/blog/${b.slug}`])} />
        </div>
      </section>
    </>
  );
}
